import { render, staticRenderFns } from "./EmbedDesainWebsite.vue?vue&type=template&id=feaf135e&scoped=true&"
import script from "./EmbedDesainWebsite.vue?vue&type=script&lang=js&"
export * from "./EmbedDesainWebsite.vue?vue&type=script&lang=js&"
import style0 from "./EmbedDesainWebsite.vue?vue&type=style&index=0&id=feaf135e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaf135e",
  null
  
)

export default component.exports